/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { ExtensionFilteringModule } from '../../extension-filtering/extension-filtering.module';
import { DeleteNfsShareModule } from '../delete-nfs-share/delete-nfs-share.module';
import { ModifyNfsShareModule } from '../modify-nfs-share/modify-nfs-share.module';
import { ClientNfsShareModule } from './../client-nfs-share/client-nfs-share.module';
import { DetailNfsShareComponent } from './detail-nfs-share.component';
@NgModule({
    declarations: [DetailNfsShareComponent],
    exports: [DetailNfsShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        DeleteNfsShareModule,
        ModifyNfsShareModule,
        ClientNfsShareModule,
        ExtensionFilteringModule,
    ],
})
export class DetailNfsShareModule { }
